var _path, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStepByStep(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 15.35H17.85V11.75H16.65V14.15H14.25V15.35ZM6.15 11.25H7.35V8.85H9.75V7.65H6.15V11.25ZM9.5 18H5.3C4.8 18 4.375 17.825 4.025 17.475C3.675 17.125 3.5 16.7 3.5 16.2V15.75H1.5C1.08579 15.75 0.75 15.4142 0.75 15V8C0.75 7.58579 1.08579 7.25 1.5 7.25H3.5V6.8C3.5 6.3 3.675 5.875 4.025 5.525C4.375 5.175 4.8 5 5.3 5H18.7C19.2 5 19.625 5.175 19.975 5.525C20.325 5.875 20.5 6.3 20.5 6.8V7.25H22.5C22.9142 7.25 23.25 7.58579 23.25 8V15C23.25 15.4142 22.9142 15.75 22.5 15.75H20.5V16.2C20.5 16.7 20.325 17.125 19.975 17.475C19.625 17.825 19.2 18 18.7 18H14.5H9.5ZM20.5 14.25H21.75V8.75H20.5V14.25ZM3.5 8.75V14.25H2.25V8.75H3.5ZM5.3 16.5H18.7C18.7667 16.5 18.8333 16.4667 18.9 16.4C18.9667 16.3333 19 16.2667 19 16.2V6.8C19 6.73333 18.9667 6.66667 18.9 6.6C18.8333 6.53333 18.7667 6.5 18.7 6.5H5.3C5.23333 6.5 5.16667 6.53333 5.1 6.6C5.03333 6.66667 5 6.73333 5 6.8V16.2C5 16.2667 5.03333 16.3333 5.1 16.4C5.16667 16.4667 5.23333 16.5 5.3 16.5Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 19.5,
    width: 2,
    height: 2,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 19.5,
    width: 2,
    height: 2,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 19.5,
    width: 2,
    height: 2,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepByStep);
export default __webpack_public_path__ + "static/media/step-by-step.88e4bb482d35c5ed077b026b60a8fcf9.svg";
export { ForwardRef as ReactComponent };